__turbopack_context__.v({
  "className": "bzOE1a_className",
  "variable": "bzOE1a_variable",
});
